import type {
  ActionCardData,
  BannerData,
  HeaderData,
  ItemListData,
  KeyValueGridData,
} from '../../types';

import { DebugCardRenderer } from './DebugCardRenderer';

type RendererProps<T> = { typeKey: string; data: T };

export const HeaderRenderer = ({ typeKey, data }: RendererProps<HeaderData>) => (
  <DebugCardRenderer primitive="header" typeKey={typeKey} data={data} />
);

export const KeyValueGridRenderer = ({ typeKey, data }: RendererProps<KeyValueGridData>) => (
  <DebugCardRenderer primitive="key_value_grid" typeKey={typeKey} data={data} />
);

export const ItemListRenderer = ({ typeKey, data }: RendererProps<ItemListData>) => (
  <DebugCardRenderer primitive="item_list" typeKey={typeKey} data={data} />
);

export const BannerRenderer = ({ typeKey, data }: RendererProps<BannerData>) => (
  <DebugCardRenderer primitive="banner" typeKey={typeKey} data={data} />
);

export const ActionCardRenderer = ({ typeKey, data }: RendererProps<ActionCardData>) => (
  <DebugCardRenderer primitive="action_card" typeKey={typeKey} data={data} />
);
